import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router/composables';
import { useI18n } from '@/helpers/composables/useI18n';

import FilterBarContentTypeItemSeo from '@/components/filter-bar/seo/FilterBarContentTypeItemSeo.vue';
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';

import { CollectionType } from '@/enums/collection-type';
import { PopularTabType, TitleObjectType } from '@/interfaces/titles';
import { NewPageType } from '@/@types/graphql-types';
import { ContentType } from '@/interfaces/filter-bar';

import { isAnyFilterActive, isFilterActive } from '@/helpers/filter-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import type { FilterCollection } from '@/stores/useFilterStoreTypes';
import { calculateUrl } from '@/helpers/state-helper';
import { useConstantStore } from '@/stores/pinia/useConstantStore';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBarContentTypeSeo',
  props: {
    collectionType: null,
    currentFilters: null,
    showCatalogTab: { type: Boolean, default: false },
    allTitle: { default: null }
  },
  setup(__props: any) {

const props = __props as { collectionType: CollectionType, currentFilters: FilterCollection, showCatalogTab: boolean, allTitle: string | null };



const { subgenresList, providersByShortName, genresByShortName } = storeToRefs(useConstantStore());
const { toggle } = useFilterStore();

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const contentTypes = computed((): ContentType[] => {
	return [
		{
			key: 'ALL_TITLES',
			translation: props.allTitle ?? (t('WEBAPP_ALL_TITLES') as string),
			value: null,
			class: 'filter-bar-content-type__button--all',
			active: !isAnyFilterActive(['content_types'], props.currentFilters),
			tabName: PopularTabType.ALL,
		},
		{
			key: 'Catalog',
			translation: t('WEBAPP_CATALOG') as string,
			value: null,
			class: 'filter-bar-content-type__button--deals-subscription',
			active: false,
			hide: !props.showCatalogTab,
			tabName: undefined,
		},
		{
			key: 'MOVIES',
			translation: t('WEBAPP_MOVIES') as string,
			value: TitleObjectType.MOVIE,
			class: 'filter-bar-content-type__button--movies',
			active: isFilterActive('content_types', TitleObjectType.MOVIE, props.currentFilters),
			tabName: PopularTabType.MOVIE,
		},
		{
			key: 'TVSHOWS',
			translation: t('WEBAPP_TVSHOWS') as string,
			value: TitleObjectType.SHOW,
			class: 'filter-bar-content-type__button--tv-shows',
			active: isFilterActive('content_types', TitleObjectType.SHOW, props.currentFilters),
			tabName: PopularTabType.SHOW,
		},
	];
});

const contentTypeUrls = computed(() => {
	const newPageType = route?.meta?.newPageType as NewPageType;
	const newPageTypeToCollectionTypes = {
		[NewPageType.New]: CollectionType.NEW,
		[NewPageType.PriceDrop]: CollectionType.PRICEDROPS,
	} as Partial<Record<NewPageType, CollectionType>>;
	return contentTypes.value.reduce((root, item) => {
		root[item.key] = calculateUrl(
			router,
			undefined,
			newPageTypeToCollectionTypes[newPageType] ?? props.collectionType,
			{
				// we only want content_types and providers in the <a href>.
				// no ?genres=crm or other filters.
				providers: props.currentFilters.providers,
				content_types: item.value !== null ? [item.value!] : [], // why null[]?
			},
			providersByShortName.value,
			genresByShortName.value,
			subgenresList.value
		);
		return root;
	}, {} as Record<string, string>);
});

function contentTypeClicked(contentType: {
	active: ContentType['active'];
	value: ContentType['value'];
	key: ContentType['key'];
	tabName?: PopularTabType;
}) {
	const selectedState: 1 | 0 = contentType.active ? 0 : 1;
	if (contentType.key === 'Catalog') {
		document
			.getElementById('catalog-jumplink')
			?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'start' });
		TrackingHelper.trackEvent('userinteraction', {
			action: 'filter_toggled',
			label: 'content_types',
			property: 'catalog',
			value: 1,
		});
	} else {
		toggle({
			filterName: 'content_types',
			value: contentType.value,
			selectedState,
		});
	}
}

return { __sfc: true,props, subgenresList, providersByShortName, genresByShortName, toggle, t, router, route, contentTypes, contentTypeUrls, contentTypeClicked, FilterBarContentTypeItemSeo, HiddenHorizontalScrollbar }
}

})